import { Box, Button, Typography } from '@material-ui/core';
import React, { useCallback } from 'react';
import { BlockedScheduleTable } from './components/BlockedScheduleTable';
import { ScheduleForm } from './components/ScheduleForm';
import { ScheduleTable } from './components/ScheduleTable';

const Schedules: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const [isNewBlockedSchedule, setIsNewBlockedSchedule] = React.useState(false);

  const handleClickOpenNewScheduleForm = useCallback(
    (isBlockedSchedule: boolean) => {
      setOpen(true);
      setIsNewBlockedSchedule(isBlockedSchedule);
    },
    [],
  );

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <Box>
      <Typography variant="h4">Horários de Atendimento</Typography>
      <Typography variant="body2">
        Abaixo estão os seus horários de atendimento padrão. Qualquer restrição
        de horário (por exemplo, horário de almoço) deve ser cadastrada como
        restrição, que será exibida na tabela &apos;Horarios não
        disponíveis&apos;.
      </Typography>
      <Box
        py={2}
        display="flex"
        justifyContent="flex-end"
        flexDirection="column"
        marginLeft="auto"
        width="180px"
      >
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleClickOpenNewScheduleForm(false)}
        >
          Novo horário
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => handleClickOpenNewScheduleForm(true)}
          style={{ marginTop: '16px' }}
        >
          Nova restrição
        </Button>
      </Box>
      <ScheduleTable />
      <Box mt={4}>
        <BlockedScheduleTable />
      </Box>
      <ScheduleForm
        open={open}
        handleClose={handleClose}
        isNewBlockedSchedule={isNewBlockedSchedule}
      />
    </Box>
  );
};

export { Schedules };
